import { render, staticRenderFns } from "./layout-page.vue?vue&type=template&id=23c1e692&scoped=true&lang=pug&"
import script from "./layout-page.vue?vue&type=script&lang=js&"
export * from "./layout-page.vue?vue&type=script&lang=js&"
import style0 from "./layout-page.vue?vue&type=style&index=0&id=23c1e692&lang=less&scoped=true&"
import style1 from "./layout-page.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1e692",
  null
  
)

export default component.exports